export function parseNumber(value) {
  if (!value) return null
  return Number(String(value).replace(/,/g, '').replace(/[^0-9.]/g, ''))
}

export function parseSignedNumber(value) {
  if (!value) return null
  const negative = /^\s*-/.test(String(value))
  const n = Number(String(value).replace(/,/g, '').replace(/[^0-9.]/g, ''))
  if (Number.isNaN(n)) return null
  return negative ? -n : n
}

export function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return ''
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export function formatSigned(value) {
  if (!value) return '—'
  const n = Number(value)
  return n < 0 ? `-${formatNumber(Math.abs(n))}` : formatNumber(n)
}

export function formatSignedTotal(value) {
  const n = Number(value || 0)
  return n < 0 ? `-${formatNumber(Math.abs(n))}` : formatNumber(n)
}

export function formatGregorian(isoDate) {
  if (!isoDate) return ''
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(isoDate))
}

export function deductionDateRangeText(ded) {
  const start = ded.calc && ded.calc.periodStart
  const end = ded.calc && ded.calc.periodEnd
  if (!start || !end) return ''
  return `${formatGregorian(start)} - ${formatGregorian(end)}`
}

export function formatDMY(isoDate) {
  const d = isoDate ? new Date(isoDate) : new Date()
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
}

export function ordinalSuffix(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  const rem100 = Math.abs(n) % 100
  if (rem100 >= 11 && rem100 <= 13) return 'th'
  switch (Math.abs(n) % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}
